import httpClient from "@/http";
import focus from "@/assets/img/focus.png"
import api from "@/api";
import {mapGetters} from "vuex";

export const MapMixin = {
    // use on component which includes MapBox as child
    props: {
        clearable: { type: Boolean, default: false }
    },
    data() {
        return {
            focus,
            selectedCoordinates: {},
            nearestAddressData: {},  // По указанным координатам может не быть объекта, поэтому координаты selectedCoordinates могут не совпадать с координатами из nearestAddressData
            selectedMunicipality: null,
            selectedMunicipalityKey: null
        }
    },
    computed: {
        ...mapGetters(['ability', 'userOrganizationMunicipalityNames', 'userOrganizationMunicipalities', 'hasMunicipalityRestrictions']),
        getAddressUrl() {
            let url = api.addresses.search.list();
            if (this.nearestAddressData && this.nearestAddressData['id']) {
                url = api.addresses.default.list() +'?id=' + this.nearestAddressData['id']
            }
            return url;
        },
        addressInitialFilters() {
            let addressFilters = []

            if (this.selectedMunicipality) {
                addressFilters.push({key: 'municipality', value: this.selectedMunicipality['id']})
            } else {
                if (this.hasMunicipalityRestrictions) {
                    const municipalities = this.userOrganizationMunicipalities;
                    for (const municipality of municipalities) {
                        addressFilters.push({key: 'municipality', value: municipality})
                    }
                }
            }

            return addressFilters
        },
    },
    methods: {
        setMapCoordinates(item) {
            this.selectedCoordinates = {lat: item.lat, lon: item.lon};
            this.form['lat'] = item.lat;
            this.form['lon'] = item.lon;
            this.$nextTick(() => {
                if (this.$refs.map) {
                    this.$refs.map.showAddress();
                }

            })
        },

        onAddressChanged(name, item) {
            this.onModelObjectSingleSelectChanged(name, item);
            this.setMapCoordinates(item);
        },

        onAddressSet(name, item) {
            this.onModelObjectSingleSelectChanged(name, item);
        },

        onAddressFocus() {
            if (this.selectedCoordinates.lat && this.selectedCoordinates.lon) {
                this.$nextTick(() => {
                    this.$refs.map.centerMap();
                })
            }
        },

        onAddressSearchStart() {
            const vm = this;
            vm.selectedCoordinates = {};
            vm.nearestAddressData = {};
            vm.$nextTick(() => {
                vm.$refs.map.showAddress();
            })
        },

        onMapClicked(coordinate) {
            const vm = this;
            const point = {lat: coordinate[1], lon: coordinate[0]};
            httpClient.get(api.addresses.reverse.list(), {params: point})
                .then((response) => {
                    vm.selectedCoordinates = point;
                    vm.form['lat'] = coordinate[1];
                    vm.form['lon'] = coordinate[0];
                    if (response['data'].hasOwnProperty('length') && response['data'].length > 0) {
                        vm.nearestAddressData = response['data'][0];
                        vm.$nextTick(() => {
                            vm.$refs.map.showAddress();
                            vm.$refs.address.fetch().then(() => {
                                vm.$refs.address.itemSelect(vm.nearestAddressData)
                            });
                        })
                    }
                })
        },

        toggleSelectedMunicipality(municipalityObject) {
            let aboutToChange = !this.selectedMunicipality || this.selectedMunicipality && this.selectedMunicipality['id'] !== municipalityObject['id']
            if (!this.clearable) {
                this.selectedMunicipality = municipalityObject
            } else {
                if (aboutToChange) {
                    this.selectedMunicipality = municipalityObject
                } else {
                    this.selectedMunicipality = null
                }
            }
            if (this.selectedCoordinates && this.selectedMunicipality) {
                this.$refs.map.centerMap(this.selectedMunicipality.lat, this.selectedMunicipality.lon);
            }
            return aboutToChange
        },
    }
}